var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueWeb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C10.7733 6 9.63251 6.36815 8.68221 7H10.0858C10.351 7 10.6054 7.10536 10.7929 7.29289L11.7929 8.29289C12.1834 8.68342 12.1834 9.31658 11.7929 9.70711L10.2071 11.2929C10.0745 11.4255 10 11.6054 10 11.7929C10 12.1834 10.3166 12.5 10.7071 12.5H13.5C14.0523 12.5 14.5 12.9477 14.5 13.5V14.1301C14.5 14.3688 14.4146 14.5996 14.2593 14.7809L11.705 17.7608C11.6202 17.8598 11.51 17.9313 11.3881 17.9692C11.5893 17.9896 11.7934 18 12 18C14.8502 18 17.2363 16.0126 17.848 13.348L17 12.5L16.2929 11.7929C16.1054 11.6054 15.851 11.5 15.5858 11.5H15C14.4477 11.5 14 11.0523 14 10.5V9.53523C14 9.20088 14.1671 8.88864 14.4453 8.70318L16.0879 7.60808C15.0165 6.61035 13.5795 6 12 6ZM6 12C6 11.3938 6.08989 10.8086 6.25707 10.2571L10.2071 14.2071C10.3946 14.3946 10.5 14.649 10.5 14.9142V17.315C10.5 17.5491 10.6174 17.7557 10.7965 17.8793C8.05956 17.322 6 14.9015 6 12ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z",
    fill: "#2A49E0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueWeb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blue_web.284a34444d4ef945c04235b2f7d7537a.svg";